export const ServiceOption = {
  flow: 'x', align: 'center space-between', padding: 'A', round: 'Z', background: 'inkMid', border: '1px solid inkBorder', cursor: 'pointer', width: '100%',
  isSelected: (el, s) => s.root.selectedService === s.name,
  '.isSelected': { borderColor: 'teal', background: 'teal.08' },
  onClick: (e, el, s) => s.root.update({ selectedService: s.name }),
  ServiceLeft: { flow: 'x', align: 'center center', gap: 'Z', ServiceEmoji: { text: (el, s) => s.emoji, fontSize: 'A' }, ServiceName: { text: (el, s) => s.name, fontSize: 'Z', fontWeight: '600', color: 'inkText' } },
  ServicePrice: { text: (el, s) => s.price, fontSize: 'Z', color: 'teal', fontWeight: '700' }
}
